import { Component, OnInit } from '@angular/core';
import { AutoCompleteModule } from 'primeng/primeng';
import { ActivatedRoute } from '@angular/router';
import { ReceiptItemService } from '../receipt-item.service';
import { ReceiptItem } from '../receipt-item';
import { ReceiptService } from '../receipt.service';
import { ProductService } from '../../products/product.service';
import { ContractorService } from '../../contractors/contractor.service';
import { CurrencyService } from '../../currencies/currency.service';
import { GlobalDataService } from '../../../../services/global-data.service';
import { CellService } from '../../cells/cell.service';
import { NgForm } from '@angular/forms';
import { Location } from '@angular/common';
import { Message } from 'primeng/primeng';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder,ReactiveFormsModule  } from '@angular/forms';

@Component({
  selector: 'app-receipt-update',
  templateUrl: './receipt-update.component.html',
  styleUrls: ['./receipt-update.component.css'],
  providers: [ 
    ReceiptItemService, 
    ReceiptService, 
    ContractorService,
    ProductService,
    CellService,
    CurrencyService
   ]
})
export class ReceiptUpdateComponent implements OnInit {

  _contractor_id: any;
  _currency_id: any;
  _delay: number = 500;
  _receipt_cart_id: any;
  _store_id: any;
  store: any;
  button_caption: string = 'Добавить';
  id: any =null;
  loading: boolean = false;
  msgs: Message[] = [];
  myForm: FormGroup;
  receiptItem: any;
  receiptItemGridData: any;
  results: string[];
  resultsSku: string[];
  text: string;
  textSku: string;
  searchFilter:any=[];
  sumTotal: any=0;
  receiptCart: any=[];
  receiptItemCart: any[]=[];

  messageDisplay:boolean = false;
  deleteIndex: any;
  blocked:boolean = false;

  askDescriptionRedactionModal: boolean = false;
  askDescription: string = "";

  selectedCell: any={};

  cellDialogInput:any="";
  cellDialogStore:any[]=[];
  cellDialogSelectedStore: string;
  cellDialogVisible:boolean = false;
  cellDialogButtonDisable:boolean = true;
  cellDialogProgressBar:boolean = false;
  
  constructor(
    private receiptItemService: ReceiptItemService,
    private receiptService: ReceiptService,
    private activatedRoute: ActivatedRoute,
    private contractorService: ContractorService,
    private productService: ProductService,
    private currencyService: CurrencyService,
    private cellService: CellService,
    private _location: Location,
    private router: Router,
    private global: GlobalDataService,
    private fb: FormBuilder
    ) {


        this.store = {name: ""};

        this.myForm  = new FormGroup({
                       product:  new FormControl("", [Validators.required]),
                       sku:  new FormControl("", [Validators.required]),
                       // bar_code:  new FormControl(),
                       cell_id:  new FormControl(),
                       // contractor_id:  new FormControl("", [Validators.required]),
                       count:  new FormControl("", [Validators.required]),
                       // base_price:  new FormControl("", [Validators.required]),
                      //  cost_price:  new FormControl("", [Validators.required]),
                      //  retail_percent:  new FormControl(),
                      //  retail_price:  new FormControl("", [Validators.required]),
                       // trade_price:  new FormControl("", [Validators.required]),
                       // trade_percent:  new FormControl(),
                       store_id:  new FormControl(""),
                      //  currency_id:  new FormControl(),
                       // receipt_cart_id:  new FormControl(),

        });

  	  activatedRoute.params.subscribe(params=>{this.id=params['id']});

      if(this.id){
          this.onLoad();
      }
      // this.cellDialogStore.push({label:this.store.name, value: {id: this.store.id, name: this.store.name}});     
   }

  ngOnInit() {

    //  this.calculateSumTotal();

    // this.currencyService.getCurrency().subscribe(response=>{
    //                         this.receiptItem.currencies=response['data'].map(function(value: any){return {label:value.name, value: value.id};});  
    //                    });

    //  this.cellService.getCellByFilter([{name: 'store_id', value : this.store['id']}],0,1).subscribe(response=>{
    //                         this.receiptItem.cells=response['data'].map(function(value: any){return {label:value.name, value: {id: value.id, name: value.name}};});  
    //                    });



    this.receiptItem={
       count: "",
      // name: "",
      // sku: "",
      // bar_code: "",
      //  currencies: []
       // cell_id: "",
      };
    // this._receipt_cart_id=this.id;
    // this._store_name=this.global.user.stores[0].name;
    // this._store_id=this.global.user.stores[0].id;
  }

    
  onLoad(){
     this.loading = true;

      this.receiptService.getReceiptById(this.id).subscribe(response=>{
        this.receiptCart = response['data'];  
        this.store = this.receiptCart['store'];
      });

      this.receiptItemService.getReceiptItemById(this.id).subscribe(response=>{
        this.receiptItemCart= response['data'];
        this.loading = false;
      });

    
  }


  delete(index: any){
      this.messageDisplay = true;
      this.deleteIndex = index;
  }

  OnAgreeDelete(){
      this.receiptItemCart.splice(this.deleteIndex,1);
      this.deleteIndex=null;
      this.messageDisplay = false;
  }

  OnDegreeDelete(){
      this.messageDisplay = false;
  }

  onEditComplete(data,index){
    console.log(data);
    console.log(this.receiptItemCart);
    this.receiptItemCart[index]['count'] = data.count;
  }


    search(event: any, attribute: string) {  
      this.searchFilter=[];
      this.searchFilter.push({name: attribute, value : event.query});
      // if(event.query.length>=1){
        this.productService.getProductByFilter(this.searchFilter,1,1)
                    .subscribe(response=>{
                      let suggest =response['data'].map(function(value: any){
                       return {id: value.id, name: value.name,  sku: value.sku, unit: {id: value.unit.id, name: value.unit.name}};
                     });
                     switch (attribute) {
                       case "name":
                          this.results=suggest;
                         break;
                      case "sku":
                         this.resultsSku=suggest;
                         break;
                     }
                    });
    }
 

  selected(value: any){
      this.text=value;
      this.textSku=value;
     // this.text=value.sku;
      // this.myForm.patchValue({sku: value.sku});
     // this.receiptItem=value;
  }


  addCart(){


    let tmpindex;

    for (let item in this.receiptItemCart){

      if(this.receiptItemCart[item].product.id==this.myForm.value['product'].id){
          tmpindex = item;
      }

    }

    if(tmpindex){

      this.receiptItemCart[tmpindex].count =((+this.receiptItemCart[tmpindex].count) + (+this.myForm.value['count'])).toFixed(2); 

    }else{
           this.receiptItemCart.push({
                                  id: "00000000-0000-0000-0000-000000000000",
                                  product : this.myForm.value['product'],
                                  count: this.myForm.value['count'] ,
                                  cell:  this.myForm.value['cell_id'], 
                                  store : this.store,
                                  total: (this.myForm.value['count'] * this.myForm.value['retail_price']).toFixed(2),
                                  index:  this.receiptItemCart.length,
                              });
    }


    //  this.onLoad();
     this.clear();
     // this.onLoad();
    // this.loading=true;
    // this.receiptItemService.addCart(this.myForm.value).subscribe(
    //   (response)=>{
    //   this.loadReceiptItemGrid(this.id);
    // },
    //  (error)=>{
    //    let str="";for (var key in JSON.parse(error._body).errors) {str+="\n" +JSON.parse(error._body).errors[key][0];} ;this.msgs.push({severity:'error', summary:'Сообщение', detail: "Ошибка: Валюта Поставщика не совпадает с валютой Продукта"});
    //    this.loading=false;   
    // }
    // );
    // this.clear(); 
  

  }

  onAddCell(){
    this.cellDialogVisible = true;
    this.cellDialogSelectedStore = this.store;
  }

  onSaveCell(event){
      this.cellDialogProgressBar= true;
      this.cellDialogButtonDisable = true;  

      this.cellService.createCell({name: event.value, store_id: this.store['id'], available: true}).subscribe(response=>{

          this.cellService.getCellByFilter([{name: 'store_id', value : this.store['id']}]).subscribe(response=>{
                            this.receiptItem.cells=response['data'].map(function(value: any){return {label:value.name, value: {id: value.id, name: value.name}};});  
                          
                          this.cellDialogProgressBar= false;  
                          this.cellDialogVisible = false;
                          this.cellDialogInput="";
                       });

           let tmp = {id: response['data']['id'], name: response['data']['name']} ;
          
         this.selectedCell = tmp;

        }  , (error)=>{  
                              this.loading=false; 
                              this.cellDialogProgressBar= false;  
                              this.cellDialogButtonDisable = false; 
                        });

  }

  onCellDialogButton(event){
    if(event.value.length>=1){
      this.cellDialogButtonDisable=false;
    }else{
      this.cellDialogButtonDisable=true;
    }
  }



  issue(){

    let items = this.receiptItemCart.map(data=>{return { 
                                                          id: data.id,
                                                          product_id: data.product.id, 
                                                          count: data.count, 
                                                          base_price: 0,
                                                          cell_id: data.cell && data.cell.id,
                                                          // cost_price: data.retail_price, 
                                                          // retail_price: data.retail_price,
                                                          // currency_id: data.currency.value,
                                                          store_id: data.store.id
                                                        }
                                                })  

    let data = {
       surcharge_percent:10,
       store_id: this.store['id'],
       old_receipt_id: this.id,
       description: this.askDescription,
       // total_expense:100,
       // must_total_base:120,
       items : items
    };
      this.blocked = true;
      this.receiptService.createReceipt(data).subscribe(response=>{
        this.router.navigate(['/dashboard/receipt']);
      });
  }

  clear(){
    this.myForm.reset();
    this.myForm.patchValue({store_id: this.store.id});
  }
   
   backClicked() {
        this._location.back();
    }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/reseipts/receipt-update/receipt-update.component.ts